import { getOrganizationStore } from '../modules/organizations';

export const OrganizationsStore = getOrganizationStore();
